import React from "react";
import BaseModel from "../base_model.js";

import { MemberUserModel } from "../users/admin/member_user_model.js";
import UserInfoCell from "../../base/table/cells/special_cells/user_info_cell.js";

class RawMemberModel extends BaseModel {

  rawListFields() {
    return [
      {
        name: "user",
        displayName: this.fieldDisplayName("user"),
        renderFunction: (participant) => {
          return <UserInfoCell user = { participant.user } />
        }
      }
    ]
  }

  rawFormFields(item = undefined) {
    return [
      {
        name: "user",
        type: "nestedModel",
        model: MemberUserModel
      },
    ]
  }

  i18nScope() {
    return "model.companies.member";
  }

}
const MemberModel = new RawMemberModel();

export { RawMemberModel, MemberModel }

